export default "__VITE_ASSET__LbBVEgxv__"